module.exports = __webpack_public_path__ + "static/media/demo.8945e7d9.png";